/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalityarchetypedescriptionachiever3Inputs */



/**
* | output |
* | --- |
* | "You’re wired for progress and growth. You love setting goals, beating your own laziness, and hyping your friends up to level up together with you." |
*
* @param {Personalityarchetypedescriptionachiever3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalityarchetypedescriptionachiever3 = /** @type {((inputs?: Personalityarchetypedescriptionachiever3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalityarchetypedescriptionachiever3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("You’re wired for progress and growth. You love setting goals, beating your own laziness, and hyping your friends up to level up together with you.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Estás diseñado para el progreso y el crecimiento. Te encanta fijar objetivos, vencer la pereza y motivar a tus amigos a mejorar juntos.")
	return /** @type {LocalizedString} */ ("Ты заряжен на преодоление и рост. Тебе нравится ставить цели, побеждать свою лень и мотивировать друзей становиться лучше вместе с тобой.")
});
export { personalityarchetypedescriptionachiever3 as "personalityArchetypeDescriptionAchiever" }